import { render, staticRenderFns } from "./SuggestContactsModal.vue?vue&type=template&id=ecb465b6&scoped=true&"
import script from "./SuggestContactsModal.vue?vue&type=script&lang=js&"
export * from "./SuggestContactsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb465b6",
  null
  
)

export default component.exports